import { loadable } from 'utils';

export const Access = loadable(() => import('./Access'), {});
export const Basic = loadable(() => import('./Basic'), {});
export const Checkout = loadable(() => import('./Checkout'), {});
export const EditRole = loadable(() => import('./EditRole'), {});
export const ChannelProfile = loadable(() => import('./ChannelProfile'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
export const Partnership = loadable(() => import('./Partnership'), {});
export const Phone = loadable(() => import('./Phone'), {});
export const SiteProfile = loadable(() => import('./SiteProfile'), {});
